import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NotificationTemplate } from "src/app/core/models/notification.model";
import { NotificationTemplateRenderer } from "../notification-template-renderer";

/**
 * Renders `{kind, content: {title, body}}`. Also the fallback renderer for
 * any unrecognized `template.kind` — see `notification-template-registry.ts`
 * — reading whatever `title`/`body`-shaped fields the unknown payload's
 * `content` happens to carry rather than rendering nothing.
 */
@Component({
  selector: "app-notification-text-renderer",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./notification-text-renderer.component.html",
  styleUrls: ["../notification-templates.scss"],
})
export class NotificationTextRendererComponent implements NotificationTemplateRenderer {
  @Input() template!: NotificationTemplate;
  @Output() respond = new EventEmitter<Record<string, unknown>>();

  get title(): string {
    return (this.template?.content as { title?: string })?.title ?? "";
  }

  get body(): string {
    return (this.template?.content as { body?: string })?.body ?? "";
  }
}
